import ArchiveSeasonStandingsDb from "./ArchiveSeasonStandingsDb.jsx";

export default function ArchiveSeasonStandingsBrandDb() {
    return (
        <ArchiveSeasonStandingsDb
            scopeType="BRAND"
            classKey=""
            title="Archiv Standings Marke"
            pillLabel="MARKE"
        />
    );
}
